export enum ApplicationType {
  NO_COVERAGE = 'noCoverage',
  FOLLOWING_INSURER = 'followingInsurer',
  LEAD_INSURER = 'leadInsurer'
}
